import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { Alert, AlertTitle } from '@material-ui/lab';

const InfoAlertBox = ({ _open, _handleClose, _alertBoxType }) => {
    return (
        <div>
            <Dialog
                fullWidth={true}
                maxWidth={'md'}
                open={_open}
                onClose={_handleClose}
                scroll={'paper'}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description">
                <DialogContent dividers={true}>
                    {
                        _alertBoxType === "info" ?
                            <Alert severity="info">
                                <AlertTitle style={{ fontSize: '22px' }}>Mysterious egg</AlertTitle>
                                <div style={{ fontSize: '16px' }}>You've discovered a mysterious egg on the island - <strong>Please complete the freshmen survey to know what it is!</strong></div>
                            </Alert>
                            :
                            <Alert severity="warning">
                                <AlertTitle style={{ fontSize: '22px' }}>Dinosaur is missing</AlertTitle>
                                <div style={{ fontSize: '16px' }}>You've been inactive. Your dinosaur misses you! - <strong>Clean up the island now to locate your dinosaur</strong></div>
                            </Alert>
                    }
                </DialogContent>
            </Dialog>
        </div>
    );
}

export { InfoAlertBox as default }